<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "help",
}
</script>

<style scoped>

</style>